/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import {
  Directive,
  ElementRef,
  Renderer2,
  OnDestroy,
  EventEmitter,
  Output,
} from '@angular/core';

@Directive({
  selector: '[longTouch]',
  standalone: false,
})
export class LongTouchDirective implements OnDestroy {
  // listener: Function;
  timer: any;
  touchDuration = 5000;
  @Output() longTouch = new EventEmitter();

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {
    this.elementRef.nativeElement.addEventListener('mousedown', () => {
      this.timer = setTimeout(this.onLongTouchEvent, this.touchDuration);
    });

    this.elementRef.nativeElement.addEventListener('touchstart', () => {
      this.timer = setTimeout(this.onLongTouchEvent, this.touchDuration);
    });

    this.elementRef.nativeElement.addEventListener('mouseup', () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    });

    this.elementRef.nativeElement.addEventListener('mouseleave', () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    });

    this.elementRef.nativeElement.addEventListener('touchend', () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    });

    this.elementRef.nativeElement.addEventListener('touchcancel', () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    });
  }

  private onLongTouchEvent = () => {
    this.longTouch.emit();
  };

  ngOnDestroy(): void {}
}
